import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Router } from '@angular/router';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

// import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatMenuModule } from '@angular/material/menu';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule} from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';
// import { FlexLayoutModule } from '@angular/flex-layout';ng update @angular/material@20
import { MatDialogModule } from '@angular/material/dialog';
import { MatNativeDateModule, MAT_DATE_LOCALE } from '@angular/material/core';

import { LoaderModule } from './_services/loader/loader.module';
import { LoaderService } from './_services/loader/loader.service';
import { WindowRef } from './_services/windowref.service';
import { ServerConn, serverConnCreator } from './_services/serverConn.service';
import { TWADialogsService } from './_services/twa-dialogs.service';
import { MqIfDirectiveModule } from './_directives/mqif.directive';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthGuard } from './_guards/auth.guard';
import { RoleGuard } from './_guards/role.guard';
import { IsActiveGuard } from './_guards/is-active.guard';
import { AuthenticationService } from './_services/authentication.service';
import { AccountService } from './_services/account.service';
// import { MainComponent } from './main/main.component';

import { DialogUploadModule } from './_components/dialog-upload/dialog-upload.module';
import { ProductReceiveDialogModule } from './_components/product-receive-dialog/product-receive-dialog.module';
import { OrderViewerModule } from './_components/order-viewer/order-viewer.module';
import { NgxStripeModule, StripeService } from 'ngx-stripe';
import { environment } from '../environments/environment';

@NgModule({ declarations: [
        AppComponent,
        // MainComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        MatIconModule,
        MatListModule,
        MatToolbarModule,
        MatMenuModule,
        MatInputModule,
        MatButtonModule,
        MatSidenavModule,
        // FlexLayoutModule,
        MatDialogModule,
        MatNativeDateModule,
        LoaderModule,
        MqIfDirectiveModule,
        AppRoutingModule,
        DialogUploadModule,
        ProductReceiveDialogModule,
        OrderViewerModule,
        NgxStripeModule.forRoot(environment.stripe_key)], providers: [
        {
            provide: ServerConn,
            useFactory: serverConnCreator,
            deps: [
                HttpClient,
                Router,
                LoaderService,
                WindowRef,
                TWADialogsService,
            ]
        },
        //   provide: MAT_DATE_LOCALE,
        //   useValue: 'es-ES'
        // },
        AuthGuard,
        RoleGuard,
        IsActiveGuard,
        AuthenticationService,
        AccountService,
        WindowRef,
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class AppModule { }
